import EXTERNAL_SERVICES from '@/project/configs/externalServicesConfig.js'
import getSample from '../raws/get.json'

export default {
  url() {
    return "https://jsonplaceholder.typicode.com/posts/1"
    return `${EXTERNAL_SERVICES.PAYMENT_HOST}/store/app/data?service=lol&userId=lol&group=${EXTERNAL_SERVICES.DEFAULT_GROUP}`
  },
  parse(raw = {}) {
    raw = getSample.permissions

    if (raw?.statusCode !== 200)
      return {
        statusCode: raw?.statusCode || 500,
        message: raw?.message || 'Failed to contact server',
        data: null,
        raw: null,
      }
    if (!Array.isArray(raw?.data))
      return {
        statusCode: 400,
        messae: 'Unexpected data got from server. Expecting Array',
        data: null,
        raw,
      }

    return {
      statusCode: 200,
      message: 'Ok',
      data: raw.data,
    }
  },
}
